import { create } from 'zustand';
import { apiClient } from '../services/api';
// Task:
// Hold an array of dishes
// Have a function to fetch dishes from your backend
// Have a loading state

const useDishStore = create((set, get) => ({
    // State
    dishes: [],
    loading: false,
    error: null,

    // Actions
    fetchDishes: async () => {
        set({ loading: true });
        try {
            const data = await apiClient.get('/api/v1/dishes');
            set({ dishes: data, loading: false });
        } catch (error) {
            set({ error: error.message, loading: false });
        }
    },

    addDish: async (dish) => {
        try {
            console.log(dish);
            const data = await apiClient.post('/api/v1/dishes', dish);
            set((state) => ({ dishes: [...state.dishes, dish] }));
        } catch (error) {
            set({ error: error.message, loading: false });
        }
    },

    updateDish: async (dishId, updatedDish) => {
        try {
            const data = await apiClient.put(`/api/v1/dishes/${dishId}`, updatedDish);
            set((state) => ({
                dishes: state.dishes.map(dish =>
                    dish.id === dishId ? { ...dish, ...data } : dish
                )
            }));
        } catch (error) {
            set({ error: error.message });
        }
    },

    deleteDish: async (dishId) => {
        try {
            await apiClient.delete(`/api/v1/dishes/${dishId}`);
            // Remove the dish from local state after successful deletion
            set((state) => ({
                dishes: state.dishes.filter(dish => dish.id !== dishId)
            }));
            return { success: true };
        } catch (error) {
            set({ error: error.message });
            throw error;
        }
    }
}
));

export default useDishStore;

